export default {
  active: true,
  stopped: false,
};
